import {emotionStyled} from '@packages/utilities/styled';
import {tokens} from '../../../themes';

export const NumberInputStepperView = emotionStyled('div')(
  {
    display: 'flex',
    width: 'max-content',
    borderRadius: '$2',
    outline: '$uiNumberInputStepperBorder',
    outlineOffset: '-1px',
    boxShadow: '$uiNumberInputStepper',
    position: 'relative',
  },
  {
    componentName: 'NumberInputStepper',
    variants: {
      isDisabled: {
        true: {
          boxShadow: 'none',
          opacity: tokens.opacities.disabled,
          cursor: 'not-allowed',
          '*': {
            cursor: 'not-allowed',
          },
        },
      },
      isFocused: {
        true: {
          boxShadow: 'none',
          outline: '$blueBorder',
          outlineOffset: '1px',
          '::before': {
            content: '""',
            position: 'absolute',
            top: '0',
            right: '0',
            bottom: '0',
            left: '0',
            border: '1px solid $uiNumberInputStepperBorder',
            pointerEvents: 'none',
            borderRadius: 'inherit',
          },
        },
      },
      isError: {
        true: {
          outline: '$redBorder',
          outlineOffset: '1px',
          boxShadow: 'none',
        },
      },
    },
  }
);
